import React, { useEffect, useState, useRef } from 'react';
import { Icon } from '@iconify/react';
interface ColumnFilterProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}
export function ColumnFilter({
  label,
  value,
  onChange,
  placeholder
}: ColumnFilterProps) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const isActive = value.length > 0;
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    }
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      setTimeout(() => inputRef.current?.focus(), 50);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === 'Escape') {
      setIsOpen(false);
    }
  };
  return <div ref={containerRef} className="inline-flex items-center gap-1.5 relative" style={{
    whiteSpace: 'nowrap'
  }} data-id="element-297">
      <span data-id="element-298">{label}</span>
      <button type="button" onClick={e => {
      e.stopPropagation();
      setIsOpen(!isOpen);
    }} className="inline-flex items-center justify-center rounded transition-colors" style={{
      width: '20px',
      height: '20px',
      color: isActive ? '#2A97DF' : '#AAAAAA',
      background: isActive ? '#D7EDFF' : 'transparent',
      border: 'none',
      cursor: 'pointer',
      borderRadius: '4px',
      flexShrink: 0
    }} title={`Filtra ${label}`} data-id="element-299">
        <Icon icon="tabler:filter" fontSize={13} data-id="element-300" />
      </button>

      {isOpen && <div style={{
      position: 'absolute',
      top: '100%',
      left: 0,
      marginTop: '6px',
      backgroundColor: 'white',
      border: '1px solid #E4E4E4',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      padding: '8px',
      zIndex: 20,
      minWidth: '200px'
    }} onClick={e => e.stopPropagation()} data-id="element-301">
          <div className="flex items-center gap-2" data-id="element-302">
            <input ref={inputRef} type="text" value={value} onChange={e => onChange(e.target.value)} onKeyDown={handleKeyDown} placeholder={placeholder || `Filtra ${label.toLowerCase()}...`} style={{
          width: '100%',
          height: '32px',
          padding: '0 8px',
          border: '1px solid #E4E4E4',
          borderRadius: '6px',
          fontSize: '13px',
          fontFamily: 'Roboto, sans-serif',
          color: '#444444',
          outline: 'none'
        }} onFocus={e => e.target.style.borderColor = '#2A97DF'} onBlur={e => e.target.style.borderColor = '#E4E4E4'} data-id="element-303" />
            {isActive && <button type="button" onClick={() => {
          onChange('');
          inputRef.current?.focus();
        }} style={{
          color: '#AAAAAA',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '2px',
          flexShrink: 0,
          display: 'flex'
        }} data-id="element-304">
                <Icon icon="tabler:x" fontSize={14} data-id="element-305" />
              </button>}
          </div>
        </div>}
    </div>;
}